/**
 * Mirrors the API's nestjsx crud `maxLimit`: a list request asking for more
 * rows is silently clamped, so client-side exports and select-all cap here.
 */
export const API_MAX_ROWS = 20000;
